import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { useAppContext } from 'new-components/OpAppScaffold/components/AppContext';
import { getAppOrigin } from 'utils/getAppOrigin';

export const useNavigateToVisitor = (orgId: number) => {
  const { app } = useAppContext();

  const navigate = useNavigate();

  const handleNavigateToVisitor = useCallback(() => {
    if (app === 'visitor') {
      navigate(0);
      return;
    }

    window.open(`${getAppOrigin('visitor')}/o/${orgId}`, '_self');
  }, [app, navigate, orgId]);

  return {
    handleNavigateToVisitor,
  };
};
